<template>
    <header class="step-navigation">
        <v-stepper
            class="transparent-stepper"
            :value="current_step_number"
            alt-labels
            flat
        >
            <v-stepper-header>
                <template v-for="item in stepper_items">
                    <v-stepper-step
                        v-if="item.type === 'step'"
                        :key="'step-' + item.id"
                        :step="item.step_number"
                        :complete="item.step_number < current_step_number"
                        :color="getStepColor(item.step_number)"
                        complete-icon="mdi-check"
                        class="clickable-step"
                        @click="handleStepClick(item.id)"
                    >
                        {{ item.name }}
                    </v-stepper-step>

                    <v-divider
                        v-if="item.type === 'divider'"
                        :key="'divider-' + item.after_id"
                    />
                </template>
            </v-stepper-header>
        </v-stepper>
    </header>
</template>

<script>
export default {
    name: 'StepNavigation',

    props: {
        steps: {
            type: Array,
            required: true,
            validator(value) {
                return value.every(step => step.id && step.name);
            }
        },

        current_step_number: {
            type: Number,
            required: true
        }
    },

    emits: ['step-click'],

    computed: {
        stepper_items() {
            const items = [];
            this.steps.forEach((step, index) => {
                items.push({
                    type: 'step',
                    id: step.id,
                    name: step.name,
                    step_number: index + 1
                });
                if (index < this.steps.length - 1) {
                    items.push({
                        type: 'divider',
                        after_id: step.id
                    });
                }
            });
            return items;
        }
    },

    methods: {
        handleStepClick(step_id) {
            this.$emit('step-click', step_id);
        },

        getStepColor(step_number) {
            if (step_number === this.current_step_number) {
                return 'primary';
            }
            if (step_number < this.current_step_number) {
                return 'success';
            }
            return 'grey';
        }
    }
}
</script>

<style lang="scss" scoped>
.step-navigation {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 999;
    padding: 0.25rem 1rem;

    .transparent-stepper {
        background: transparent;
        box-shadow: none;
        max-width: var(--max-width, 1400px);
        margin: 0 auto;
    }

    :deep(.v-stepper__header) {
        box-shadow: none;
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;

        &::-webkit-scrollbar {
            height: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.2);
            border-radius: 2px;
        }
    }

    :deep(.v-stepper__step) {
        flex-shrink: 0;
        padding: 1rem 0.75rem;

        @media (max-width: 768px) {
            padding: 0.75rem 0.5rem;
        }
    }

    :deep(.v-stepper__step__step) {
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;

        &:hover {
            transform: scale(1.1);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        }
    }

    :deep(.v-stepper__label) {
        font-size: 0.75rem;
        text-align: center;
        white-space: nowrap;

        @media (max-width: 600px) {
            display: block !important;
            font-size: 0.65rem;
        }
    }

    :deep(.v-divider) {
        margin: 1.5rem -0.5rem 0;
        flex-shrink: 0;
        min-width: 1.25rem;
    }

    .clickable-step {
        cursor: pointer;
    }
}
</style>
